<template>
  <div class="examples-in-use">
    <div class="row align-bottom">
      <div>
        <h3>Icons in Use</h3>
        <p class="line-length-lg">
          Fake it 'til you make it, amiright? Here are some examples of how you could use Font Awesome
          {{ categoryLabel }} icons in your projects, whether they're apps, interfaces, or print designs.
        </p>
      </div>
    </div>
    <div
      class="row roomy padding-y-2xl align-stretch"
      style=""
    >
      <div
        class="column-12 laptop:column-4 margin-bottom-xl"
        style=""
      >
        <div
          class="card padding-top-0"
          style="--card-background: var(--category-color); height: 100%"
        >
          <div
            class="example-mobileapp"
            style="margin: 0 auto; background-color: var(--category-color-alt); border-radius: 0 0 var(--border-radius-lg) var(--border-radius-lg)"
          >
            <h4 class="sr-only">An example of a mobile app using icons</h4>
            <div style="padding: var(--spacing-md); color: var(--category-color)">
              <i
                :class="[`fa-${selectedFamily} fas fa-${getIcon(1)} fa-fw fa-2x fa-fade`]"
                style="--fa-animation-duration: 3s"
              />
              <span class="size-lg strong display-block margin-top-xs">Loading...</span>
            </div>
            <div
              class="display-flex align-between"
              style="
                background-color: var(--fa-navy);
                padding: var(--spacing-sm) var(--spacing-xs);
                border-radius: 0 0 var(--border-radius-lg) var(--border-radius-lg);
                --button-border-radius: var(--border-radius-lg);
                --button-padding: var(--button-padding-vertical);
              "
            >
              <button
                v-for="(item, index) in previewIcons"
                :key="item.previewIcons"
                :class="['flat', { 'laptop:display-none': index > 3 }]"
                style="
                  --button-hover-background: var(--category-color-alt);
                  --button-color: var(--white);
                  --button-background: var(--category-color-alt);
                  --button-margin-bottom: 0;
                "
              >
                <i :class="[`fa-${selectedFamily} ${item.style} fa-${item.icon} fa-fw fa-xl`]" />
                <span class="sr-only">example button</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        class="column-12 tablet:column-6 laptop:column-4 margin-bottom-xl"
        style=""
      >
        <div
          class="card display-flex align-center"
          style="flex-direction: column; --card-background: var(--category-color-alt); height: 100%"
        >
          <div
            class="example-sign display-flex margin-bottom-lg"
            style="z-index: 2; border-radius: var(--border-radius-md); background-color: var(--white)"
          >
            <h4 class="sr-only">An example of a signs with icons</h4>
            <div
              class="text-left text-truncate padding-x-md padding-y-lg laptop:padding-x-lg"
              style="flex-grow: 3; color: var(--category-color-alt)"
            >
              <i :class="[`fa-${selectedFamily} fas fa-fw fa-2xl fa-${getIcon(5)}`]" />
              <span
                class="margin-left-md"
                style="color: var(--fa-navy-transparent5)"
              >
                {{ getIcon(5) }}
              </span>
            </div>
            <div
              style="
                padding: var(--spacing-lg);
                background-color: var(--fa-navy);
                color: var(--white);
                border-radius: 0 var(--border-radius-md) var(--border-radius-md) 0;
              "
            >
              <i class="fas fa-fw fa-xl fa-arrow-up" />
            </div>
          </div>

          <div
            class="sign display-flex margin-bottom-lg"
            style="z-index: 2; border-radius: var(--border-radius-md); background-color: var(--white)"
          >
            <div
              class="text-left text-truncate padding-x-md padding-y-lg laptop:padding-x-lg"
              style="flex-grow: 3; color: var(--category-color-alt)"
            >
              <i :class="[`fa-${selectedFamily} fas fa-fw fa-2xl fa-${getIcon(6)}`]" />
              <span
                class="margin-left-md"
                style="color: var(--fa-navy-transparent5)"
              >
                {{ getIcon(6) }}
              </span>
            </div>
            <div
              style="
                padding: var(--spacing-lg);
                background-color: var(--fa-navy);
                color: var(--white);
                border-radius: 0 var(--border-radius-md) var(--border-radius-md) 0;
              "
            >
              <i class="fas fa-fw fa-xl fa-arrow-right" />
            </div>
          </div>
          <div style="z-index: 1; position: absolute; top: 0; left: 15%; width: 15px; height: 65%; background-color: var(--category-color)">&nbsp;</div>
          <div style="z-index: 1; position: absolute; top: 0; right: 15%; width: 15px; height: 65%; background-color: var(--category-color)">&nbsp;</div>
        </div>
      </div>

      <div
        class="column-12 tablet:column-6 laptop:column-4 margin-bottom-xl"
        style=""
      >
        <div
          class="card display-flex flex-column flex-content-end text-left padding-bottom-0"
          style="--card-background: var(--category-color-alt); height: 100%"
        >
          <div
            class="example-todos text-capitalize text-center padding-xs"
            style="color: var(--category-color); background-color: var(--fa-navy); border-radius: var(--border-radius-md) var(--border-radius-md) 0 0"
          >
            <h4 class="sr-only">An example of a to-do list with icons</h4>
            {{ categoryLabel }} icons
          </div>
          <div style="background-color: var(--white)">
            <ul class="fa-ul">
              <li style="padding: var(--spacing-sm); border-bottom: 1px solid var(--fa-gravy); color: var(--category-color)">
                <span class="fa-li"><i class="far fa-check-square" /></span>
                <div class="text-left text-truncate">
                  <i :class="[`fa-${selectedFamily} fas fa-fw fa-xl fa-${getIcon(1)}`]" />
                  <span class="text-truncate margin-left-md">{{ getIcon(1) }}</span>
                </div>
              </li>
              <li style="padding: var(--spacing-sm); border-bottom: 1px solid var(--fa-gravy)">
                <span class="fa-li">
                  <i
                    class="far fa-square"
                    style="color: var(--category-color)"
                  />
                </span>
                <div class="text-left text-truncate">
                  <i :class="[`fa-${selectedFamily} fas fa-fw fa-xl fa-${getIcon(2)}`]" />
                  <span
                    class="text-truncate margin-left-md"
                    style="color: var(--fa-navy-transparent5)"
                  >
                    {{ getIcon(2) }}
                  </span>
                </div>
              </li>
              <li style="padding: var(--spacing-sm)">
                <span class="fa-li">
                  <i
                    class="far fa-square"
                    style="color: var(--category-color)"
                  />
                </span>
                <div class="text-left text-truncate">
                  <i :class="[`fa-${selectedFamily} fas fa-fw fa-xl fa-${getIcon(3)}`]" />
                  <span
                    class="margin-left-md"
                    style="color: var(--fa-navy-transparent5)"
                  >
                    {{ getIcon(3) }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="column-12 laptop:column-6 margin-bottom-xl"
        style=""
      >
        <div
          class="card display-flex flex-column flex-content-end text-left padding-bottom-0"
          style="--card-background: var(--category-color); height: 100%"
        >
          <div
            class="examples-website display-flex padding-xs align-middle"
            style="color: var(--category-color); background-color: var(--fa-navy); border-radius: var(--border-radius-md) var(--border-radius-md) 0 0"
          >
            <h4 class="sr-only">An example of a website with icons</h4>
            <div class="display-flex align-middle">
              <div
                class="display-inline-block margin-left-3xs"
                style="width: 15px; height: 15px; background-color: var(--fa-dk-navy); border-radius: var(--border-radius-lg)"
              >
                &nbsp;
              </div>
              <div
                class="display-inline-block margin-left-3xs"
                style="width: 15px; height: 15px; background-color: var(--fa-dk-navy); border-radius: var(--border-radius-lg)"
              >
                &nbsp;
              </div>
              <div
                class="display-inline-block margin-left-3xs"
                style="width: 15px; height: 15px; background-color: var(--fa-dk-navy); border-radius: var(--border-radius-lg)"
              >
                &nbsp;
              </div>
            </div>
            <div
              class="text-center padding-x-4xl padding-y-4xs margin-x-2xl"
              style="flex-grow: 2; opacity: 0.7; background-color: var(--fa-dk-navy); border-radius: var(--border-radius-lg)"
            >
              {{ category }}-opedia
            </div>
          </div>
          <div
            class="display-flex"
            style="background-color: var(--white)"
          >
            <div class="column-6 padding-lg">
              <span
                class="display-block strong margin-bottom-sm"
                style="color: var(--category-color-alt)"
              >
                The web's premier resource for {{ categoryLabel }} icons.
              </span>
              <span
                class="display-block"
                style="color: var(--fa-dk-gravy)"
              >
                Of all the fake websites in the world, this is the best.
              </span>
            </div>
            <div class="column-6 padding-lg">
              <div class="display-flex align-between padding-md">
                <i
                  :class="[`fa-${selectedFamily} ${getRandomStyle()} fa-${getIcon(1)} fa-fw fa-2x`]"
                  style="color: var(--category-color-alt)"
                />
                <i
                  :class="[`fa-${selectedFamily} ${getRandomStyle()} fa-${getIcon(2)} fa-fw fa-2x`]"
                  style="color: var(--fa-navy)"
                />
                <i
                  :class="[`fa-${selectedFamily} ${getRandomStyle()} fa-${getIcon(3)} fa-fw fa-2x`]"
                  style="color: var(--category-color-alt)"
                />
              </div>
              <div class="display-flex align-between padding-md">
                <i
                  :class="[`fa-${selectedFamily} ${getRandomStyle()} fa-${getIcon(4)} fa-fw fa-2x`]"
                  style="color: var(--fa-navy)"
                />
                <i
                  :class="[`fa-${selectedFamily} ${getRandomStyle()} fa-${getIcon(5)} fa-fw fa-2x`]"
                  style="color: var(--category-color-alt)"
                />
                <i
                  :class="[`fa-${selectedFamily} ${getRandomStyle()} fa-${getIcon(6)} fa-fw fa-2x`]"
                  style="color: var(--fa-navy)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="column-12 tablet:column-6 laptop:column-6 margin-bottom-xl"
        style=""
      >
        <div
          class="card padding-x-3xl laptop:padding-x-6xl"
          style="--card-background: var(--fa-navy); --card-color: var(--white); height: 100%"
        >
          <div
            class="examples-transitline display-flex flex-content-center flex-column"
            style="height: 100%"
          >
            <h4 class="sr-only">An example of a transit line using icons</h4>
            <div class="display-flex flex-content-between">
              <i
                :class="[`fa-${selectedFamily} fas fa-${getRandomIcon()} fa-fw fa-2x`]"
                style="color: var(--category-color)"
              />
              <i
                :class="[`fa-${selectedFamily} fas fa-${getRandomIcon()} fa-fw fa-2x`]"
                style="color: var(--category-color)"
              />
              <i
                :class="[`fa-${selectedFamily} ${getRandomStyle()} fa-${getRandomIcon()} fa-fw fa-2x fa-beat-fade`]"
                style="color: var(--fa-gravy); --fa-animation-duration: 2s"
              />
              <i
                :class="[`fa-${selectedFamily} ${getRandomStyle()} fa-${getRandomIcon()} fa-fw fa-2x`]"
                style="color: var(--fa-gravy)"
              />
            </div>
            <div
              class="position-relative display-flex margin-y-3xl margin-x-sm size-xs"
              style="height: 1em"
            >
              <div
                class="position-absolute z-index-2"
                style="
                  top: -0.5em;
                  left: 0;
                  border: 0.5em solid var(--white);
                  height: 2em;
                  width: 2em;
                  border-radius: var(--border-radius-lg);
                  background-color: var(--category-color);
                "
              >
                &nbsp;
              </div>

              <div
                class="padding-4xs"
                style="flex-grow: 2; background: var(--white); border-radius: var(--border-radius-lg)"
              >
                <div style="border-top: 0.5em solid var(--category-color); height: 1px">&nbsp;</div>
              </div>

              <div
                class="position-absolute z-index-2"
                style="
                  top: -0.5em;
                  left: 31%;
                  border: 0.5em solid var(--white);
                  height: 2em;
                  width: 2em;
                  border-radius: var(--border-radius-lg);
                  background-color: var(--category-color);
                "
              >
                &nbsp;
              </div>

              <div
                class="padding-4xs"
                style="flex-grow: 2; background: var(--white); border-radius: var(--border-radius-lg)"
              >
                <div style="border-top: 0.5em dotted var(--category-color); height: 1px">&nbsp;</div>
              </div>

              <div
                class="position-absolute z-index-2"
                style="
                  top: -0.5em;
                  right: 31%;
                  border: 0.5em solid var(--white);
                  height: 2em;
                  width: 2em;
                  border-radius: var(--border-radius-lg);
                  background-color: var(--category-color);
                "
              >
                &nbsp;
              </div>

              <div
                class="padding-4xs"
                style="flex-grow: 2; background: var(--white); border-radius: var(--border-radius-lg)"
              >
                <div style="border-top: 0.5em solid var(--white); height: 1px">&nbsp;</div>
              </div>

              <div
                class="position-absolute z-index-2"
                style="
                  top: -0.5em;
                  right: 0;
                  border: 0.5em solid var(--white);
                  height: 2em;
                  width: 2em;
                  border-radius: var(--border-radius-lg);
                  background-color: var(--category-color);
                "
              >
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="column-12 tablet:column-6 laptop:column-4 margin-bottom-xl"
        style=""
      >
        <div
          class="card display-flex flex-content-center flex-items-center"
          style="
            color: var(--white);
            height: 100%;
            background: center / cover var(--fa-navy) url('https://img.fortawesome.com/1ce05b4b/background-bricks2.png') repeat;
          "
        >
          <i :class="[`fa-${selectedFamily} fas fa-${categoryIcon} fa-fw fa-6x`]" />
        </div>
      </div>

      <div
        class="column-12 tablet:column-6 laptop:column-4 margin-bottom-xl"
        style=""
      >
        <div
          class="card display-flex flex-column flex-content-end text-left padding-bottom-0 padding-x-2xl"
          style="--card-background: var(--category-color); height: 100%; overflow: hidden"
        >
          <div
            class="examples-flyer position-relative padding-x-xl padding-top-xl"
            style="background-color: var(--white); margin-bottom: -2em"
          >
            <h4 class="sr-only">An example of a flyer with icons</h4>
            <p class="padding-x-lg text-center">
              <span
                class="display-block size-xl strong text-uppercase margin-bottom-xs"
                style="color: var(--category-color-alt)"
              >
                Icons For Sale
              </span>
              <small class="display-block muted">Fresh, hot icons for sale! Call us at (555) 867-5309 for more info.</small>
            </p>
            <div class="display-flex flex-content-around padding-md">
              <i :class="[`fa-${selectedFamily} fal fa-${getRandomIcon()} fa-fw fa-2x`]" />
              <i :class="[`fa-${selectedFamily} ${canUseThin ? 'fat' : 'far'} fa-${getRandomIcon()} fa-fw fa-2x`]" />
              <i :class="[`fa-${selectedFamily} fal fa-${getRandomIcon()} fa-fw fa-2x`]" />
              <i :class="[`fa-${selectedFamily} ${canUseThin ? 'fat' : 'far'} fa-${getRandomIcon()} fa-fw fa-2x`]" />
            </div>
            <div class="display-flex flex-content-around padding-md">
              <i :class="[`fa-${selectedFamily} ${canUseThin ? 'fat' : 'far'} fa-${getRandomIcon()} fa-fw fa-2x`]" />
              <i :class="[`fa-${selectedFamily} fal fa-${getRandomIcon()} fa-fw fa-2x`]" />
              <i :class="[`fa-${selectedFamily} ${canUseThin ? 'fat' : 'far'} fa-${getRandomIcon()} fa-fw fa-2x`]" />
              <i :class="[`fa-${selectedFamily} fal fa-${getRandomIcon()} fa-fw fa-2x`]" />
            </div>
            <div
              class="position-absolute"
              style="opacity: 0.3; top: -0.5em; left: -1.5em; height: 2em; width: 4em; background-color: var(--fa-navy-transparent5); transform: rotate(-45deg)"
            >
              &nbsp;
            </div>
            <div
              class="position-absolute"
              style="opacity: 0.3; top: -0.5em; right: -1.5em; height: 2em; width: 4em; background-color: var(--fa-navy-transparent5); transform: rotate(45deg)"
            >
              &nbsp;
            </div>
          </div>
        </div>
      </div>

      <div
        class="column-12 tablet:column-6 laptop:column-4 margin-bottom-xl"
        style=""
      >
        <div
          class="card"
          style="--card-background: var(--category-color); height: 100%"
        >
          <div
            class="examples-buttons display-flex flex-column flex-content-center"
            style="height: 100%"
          >
            <h4 class="sr-only">An example of a buttons with icons</h4>
            <button
              class="block"
              style="--button-active-background: var(--category-color-alt); --button-hover-background: var(--category-color)"
            >
              <i
                :class="[`fa-${selectedFamily} fal fa-${getIcon(1)} fa-fw fa-xl margin-right-md`]"
                style="color: var(--category-color-alt)"
              />
              Make It So
            </button>
            <button
              class="block active"
              style="--button-active-background: var(--category-color-alt); --button-hover-background: var(--category-color)"
            >
              <i
                :class="[`fa-${selectedFamily} fal fa-${getIcon(1)} fa-fw fa-xl margin-right-md fa-spin`]"
                style="color: var(--white); --fa-animation-duration: 2s"
              />
              Making It So
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectHits } from 'instantsearch.js/es/connectors'

  export default {
    name: 'CategoryExamples',

    mixins: [createWidgetMixin({ connector: connectHits })],

    props: {
      category: {
        type: String
      },
      categoryLabel: {
        type: String
      },
      selectedStyle: {
        type: String
      },
      categoryIcon: {
        type: String
      },
      version: {
        type: Number
      },
      selectedFamily: {
        type: String
      }
    },

    data() {
      return {
        categoryChanged: false,
        previewMode: 'day',
        v5Styles: ['fas', 'far', 'fal', 'fad'],
        v6Styles: ['fa-solid', 'fa-thin', 'fa-regular', 'fa-light'],
        v6StylesDuotone: ['fa-solid'],
        v6StylesSharpDuotone: ['fa-solid', 'fa-regular'],
        previewIconCount: 10,
        previewIcons: [],
        iconsLoaded: false
      }
    },

    computed: {
      canUseThin() {
        return this.version !== 5
      }
    },

    watch: {
      'category'() {
        this.categoryChanged = true
      },
      'state.hits'(oldHits, newHits) {
        if (!this.iconsLoaded) {
          // Handle initial load of header icons
          this.previewIcons = []
          this.headIcons = this.loadRandomIcons()
          this.iconsLoaded = true
        } else if (this.categoryChanged) {
          if (!this.iconsLoaded || (newHits && newHits.length !== oldHits.length)) {
            this.previewIcons = []
            this.headIcons = this.loadRandomIcons()
            this.categoryChanged = false
          }
        }
      }
    },

    methods: {
      getIcon(id) {
        this.loadRandomIcons()
        return this.state ? this.previewIcons[id].icon : ''
      },

      getFamily() {
        if (this.selectedFamily === 'sharp-duotone' || this.selectedFamily === 'sharp') {
          return 'sharp'
        } else {
          return 'classic'
        }
      },

      loadRandomIcons() {
        if (this.state && this.previewIcons.length == 0) {
          for (let i = 0; i < this.previewIconCount; i++) {
            const style = this.getRandomStyle()
            const family = this.getFamily()

            this.previewIcons.push({
              icon: this.getRandomIcon(),
              style: style,
              family: family
            })
          }
        }
      },

      getRandomIcon() {
        if (this.state && this.state.hits.length > 0) {
          const result = this.getRandomItem(this.state.hits)
          return result.name
        } else {
          return ''
        }
      },

      getRandomStyle() {
        if (this.version !== 5 && this.selectedFamily === 'duotone') {
          return this.getRandomItem(this.v6StylesDuotone)
        } else if (this.version !== 5 && this.selectedFamily === 'sharp-duotone') {
          return this.getRandomItem(this.v6StylesSharpDuotone)
        } else if (this.version === 5) {
          return this.getRandomItem(this.v5Styles)
        } else {
          return this.getRandomItem(this.v6Styles)
        }
      },

      getRandomItem(items) {
        return items[Math.floor(Math.random() * items.length)]
      },

      setPreviewMode(mode) {
        this.previewMode = mode
      }
    }
  }
</script>
